import {SideNavigationMenuItemElementProps} from './SideNavigationMenuItemElementTypes';
import * as Accordion from '@radix-ui/react-accordion';
import styles from '../SideNavigationMenuItem.module.scss';
import {IconMinus, IconPlus} from '../../../icons';
import {SideNavigationMenuItemDropdown} from './SideNavigationMenuItemDropdown';
import {useEffect, useState} from 'react';
import {useAccordionContext} from '../../side-navigation-contexts/SideNavigationAccordionContext';

export const SideNavigationMenuItemAccordion = (props: SideNavigationMenuItemElementProps) => {

    const {openAccordion, setOpenAccordion, nextAccordion, setNextAccordion} = useAccordionContext();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleOpen = () => {
        if (props.children && props.children.length > 0) {
            if (openAccordion.id === props.id && openAccordion.label === props.label) {
                setIsOpen(false);
                setOpenAccordion({label: '', id: -1});
            } else {
                setNextAccordion({label: props.label, id: props.id});
            }
        }
    }

    useEffect(() => {
        if (openAccordion && (openAccordion.id !== props.id || openAccordion.label !== props.label) && isOpen) {
            setIsOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openAccordion]);

    useEffect(() => {
        if (nextAccordion.id === props.id && nextAccordion.label === props.label && !isOpen) {
            setIsOpen(true);
            setOpenAccordion(nextAccordion);
            setNextAccordion({label: '', id: -1});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextAccordion]);


    return (
        <Accordion.Root
            data-level={props.level} type={'single'}
            collapsible={isOpen && props.children && props.children.length > 0}
            asChild
        >
            <Accordion.Item aria-expanded={isOpen} data-state={isOpen ? 'open' : 'closed'}
                            className={styles.accordionItemContainer} value={props.label}>
                <>
                    <Accordion.Trigger aria-expanded={isOpen} data-state={isOpen ? 'open' : 'closed'} tabIndex={0}
                                       data-accordion={true} onClick={handleOpen} data-level={props.level}
                                       className={props.baseContainerStyling} aria-label={props.label}>
                        <>
                            <div className={styles.logoLabelContainer}>
                                {
                                    props.Icon &&
                                    <span className={styles.badgeIconContainer}>
                                        <props.Icon className={styles.badgeIcon}/>
                                    </span>
                                }
                                <span className={styles.label}>{props.label}</span>
                            </div>

                            {
                                props.children && props.children.length > 0 && isOpen ? (
                                    <IconMinus data-level={props.level} className={styles.menuItemChildrenIcon}/>
                                ) : props.children && props.children.length > 0 ? (
                                    <IconPlus data-level={props.level} className={styles.menuItemChildrenIcon}/>
                                ) : null
                            }
                        </>
                    </Accordion.Trigger>
                    {
                        props.children && props.children.length > 0 && isOpen &&
                        <Accordion.Content autoFocus className={styles.accordionChildItemsContainer} tabIndex={0}>
                            <span className={styles.line}/>
                            <div className={styles.accordionChildItemsContainerInner}>
                                {
                                    props.children && props.children.sort((a, b) => a.order - b.order).map((child, index) => (
                                        <SideNavigationMenuItemDropdown
                                            {...child}
                                            key={index}
                                            isSubMenuItem={false}
                                            baseContainerStyling={props.baseContainerStyling}
                                            isTertiaryChild={false}
                                        />
                                    ))
                                }
                            </div>
                        </Accordion.Content>
                    }
                </>
            </Accordion.Item>
        </Accordion.Root>
    );
}